import React from 'react';
import { Typography } from '@material-ui/core';
import DateRangeRoundedIcon from '@material-ui/icons/DateRangeRounded';
import { format } from 'date-fns';
import { useStyles } from '../styles';

const DateRangeInput = ({ startDate, endDate, onClick, placeholder = "Оберіть діапазон дат" }) => {
    const classes = useStyles();

    const formatDate = (date) => {
        return date ? format(date, 'dd.MM.yyyy') : '';
    };

    const displayText = () => {
        if (!startDate && !endDate) {
            return placeholder;
        }

        if (startDate && !endDate) {
            return formatDate(startDate);
        }

        if (startDate && endDate) {
            return `${formatDate(startDate)} - ${formatDate(endDate)}`;
        }

        return placeholder;
    };

    const hasValue = startDate || endDate;

    return (
        <div className={classes.inputWrapper}>
            <div className={classes.input} onClick={onClick} role="button" tabIndex={0}>
                <DateRangeRoundedIcon className={classes.inputIcon} />
                <Typography
                    className={hasValue ? classes.inputText : classes.inputPlaceholder}
                >
                    {displayText()}
                </Typography>
            </div>
        </div>
    );
};

export default DateRangeInput;
